import { ApiClient, type ApiClientOptions } from './client';
import { createAuthApi } from './auth';
import { createChatApi } from './chat';
import { createArticlesApi, createRequestsApi, createSiteContentApi } from './content';
import { createMediaApi } from './media';
import { createStaffApi } from './staff';
import { createStaffAuthApi } from './staff';

export type { ApiClientOptions } from './client';
export {
  ApiClient,
  ApiError,
  createLocalStorageTokenStorage,
  createMemoryTokenStorage,
  type TokenStorage,
} from './client';

export function createApiClient(options: ApiClientOptions) {
  const client = new ApiClient(options);
  return {
    client,
    auth: createAuthApi(client),
    staffAuth: createStaffAuthApi(client),
    staff: createStaffApi(client),
    chat: createChatApi(client),
    media: createMediaApi(client),
    articles: createArticlesApi(client),
    content: createSiteContentApi(client),
    requests: createRequestsApi(client),
  };
}

export type LexApiClient = ReturnType<typeof createApiClient>;
